import {
  MPAY_CONFIG
} from '../apis/user.js'
import {
  mapState
} from 'vuex'
var mpayScript
export default {
  computed: {
    ...mapState(['browser'])
  },
  methods: {
    loadMpayScript (apiList, success = () => {}) {
      // const ua = navigator.userAgent.toLowerCase() && ua.indexOf('mpay') > -1
      if (!mpayScript) {
        mpayScript = window.document.createElement('script')
        mpayScript.src = 'https://pay.macaupass.com/data/static/js/mpayjsapi.min.js'
        mpayScript.onload = () => {
          console.log('mpay加载完成')
          this.loadMpayConfig(apiList, success)
        }
        var head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
        head.insertBefore(mpayScript, head.firstChild)
      } else {
        console.log('mpay已加载')
        this.loadMpayConfig(apiList, success)
      }
    },
    loadMpayConfig (apiList, success = () => {}) {
      this.$post(
        MPAY_CONFIG, {
          url: window.location.href
          // appId: 'mpljlmRZE2JJEFlfQf',
          // jsApiList: apiList,
          // debug: true
        },
        resp => {
          if (window.mp && resp.data) {
            const mdata = resp.data
            console.log('ddddd', resp.data)
            window.mp.config({
              debug: 0,
              appId: mdata.appid,
              timestamp: mdata.timestamp,
              nonceStr: mdata.nonceStr,
              signature: mdata.signature,
              jsApiList: apiList
            })
            window.mp.ready(function () {
              success && success()
              console.log('mpay资源已准备')
            })
          }
        },
        error => {
          this.$toast(error)
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      )
    }
  }
}
